/**
 * Standard shadcn helper — `clsx + tailwind-merge`.
 *
 * Merges conditional class names AND collapses Tailwind class conflicts
 * (e.g. `cn('px-2', 'px-4')` → `'px-4'`).
 */
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
